export type CategoryException = {
  id: string;
  name: string;
  value: string;
};

export const splitTitleAndCategory = ({
  title,
  titlesCategoriesExceptions
}: {
  title: string;
  titlesCategoriesExceptions?: CategoryException[];
}) => {
  let name: string;
  let category: string;

  const categoryException = titlesCategoriesExceptions?.find((c) =>
    title.toLowerCase().includes(c.name)
  );

  if (categoryException) {
    const wordsN = categoryException.name.split(' ').length;

    name = title.split(' ').slice(0, -wordsN).join(' ');
    category = categoryException.value;

    return { title: name, category };
  } else {
    name = title.split(' ').slice(0, -1).join(' ');
    category = title.split(' ').slice(-1).join(' ');

    return { title: name, category };
  }
};

export const splitTitleAndCategoryByHandle = ({
  handle,
  titlesCategoriesExceptions
}: {
  handle: string;
  titlesCategoriesExceptions?: CategoryException[];
}) => {
  const title = handle
    .replace(/\u200B/g, '')
    .trim()
    .replace(/-/g, ' ');

  return splitTitleAndCategory({ title, titlesCategoriesExceptions });
};
